import script from "./JaStreamGroupEditSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./JaStreamGroupEditSchedule.vue?vue&type=script&setup=true&lang=js"

import "./JaStreamGroupEditSchedule.vue?vue&type=style&index=0&id=228f8cef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228f8cef"]])

export default __exports__